import { Prop } from 'vue-property-decorator';

export default {
  props: {
    i18n: { type: Object, required: true }
  }
};
